// Centralized 9-column Sales Order CSV format used by both the per-SO download
// (OrderDetailPage) and the bulk Orders export (OrdersPage). Keeping the column
// shape in one place ensures the customer's ERP intake stays consistent.

export const ORDER_CSV_HEADERS = [
  'SO No', 'Date', 'Customer Name', 'Item (Part No)', 'Customer P/N',
  'Quantity', 'Unit Price', 'Total Value', 'Delivery Terms',
];

const formatOrderDate = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

// Returns a list of CSV rows (each row = array of cells) for one order.
// If the order has no line items, emits one empty placeholder row so the SO
// still appears in the export (matches existing bulk export behavior).
export function orderToCsvRows(order) {
  if (!order) return [];
  const orderDate = formatOrderDate(order.created_at);
  const items = order.items || [];
  if (items.length === 0) {
    return [[
      order.order_number || '', orderDate, order.customer_name || '',
      '-', '-', '0', '0.00', '0.00', order.delivery_terms || '',
    ]];
  }
  return items.map((item) => [
    order.order_number || '',
    orderDate,
    order.customer_name || '',
    item.part_internal_no || item.description || '',
    item.customer_part_no || '-',
    (item.quantity || 0).toString(),
    Number(item.unit_price || 0).toFixed(4),
    Number(item.line_total || ((item.quantity || 0) * (item.unit_price || 0))).toFixed(2),
    order.delivery_terms || '',
  ]);
}

// Converts header + rows arrays into a CSV string (Excel-safe quoting).
export function rowsToCsv(headers, rows) {
  const quote = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  return [headers.join(','), ...rows.map((r) => r.map(quote).join(','))].join('\n');
}

// Triggers a browser download for the given CSV string under the given filename.
export function downloadCsv(csv, filename) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}
